// Generated by scripts/prenoms/import.py.
export const DEPARTMENT_LIST = [
  { code: "01", name: "Ain", slug: "ain-01" },
  { code: "02", name: "Aisne", slug: "aisne-02" },
  { code: "03", name: "Allier", slug: "allier-03" },
  { code: "04", name: "Alpes-de-Haute-Provence", slug: "alpes-de-haute-provence-04" },
  { code: "05", name: "Hautes-Alpes", slug: "hautes-alpes-05" },
  { code: "06", name: "Alpes-Maritimes", slug: "alpes-maritimes-06" },
  { code: "07", name: "Ardèche", slug: "ardeche-07" },
  { code: "08", name: "Ardennes", slug: "ardennes-08" },
  { code: "09", name: "Ariège", slug: "ariege-09" },
  { code: "10", name: "Aube", slug: "aube-10" },
  { code: "11", name: "Aude", slug: "aude-11" },
  { code: "12", name: "Aveyron", slug: "aveyron-12" },
  { code: "13", name: "Bouches-du-Rhône", slug: "bouches-du-rhone-13" },
  { code: "14", name: "Calvados", slug: "calvados-14" },
  { code: "15", name: "Cantal", slug: "cantal-15" },
  { code: "16", name: "Charente", slug: "charente-16" },
  { code: "17", name: "Charente-Maritime", slug: "charente-maritime-17" },
  { code: "18", name: "Cher", slug: "cher-18" },
  { code: "19", name: "Corrèze", slug: "correze-19" },
  { code: "21", name: "Côte-d'Or", slug: "cote-d-or-21" },
  { code: "22", name: "Côtes-d'Armor", slug: "cotes-d-armor-22" },
  { code: "23", name: "Creuse", slug: "creuse-23" },
  { code: "24", name: "Dordogne", slug: "dordogne-24" },
  { code: "25", name: "Doubs", slug: "doubs-25" },
  { code: "26", name: "Drôme", slug: "drome-26" },
  { code: "27", name: "Eure", slug: "eure-27" },
  { code: "28", name: "Eure-et-Loir", slug: "eure-et-loir-28" },
  { code: "29", name: "Finistère", slug: "finistere-29" },
  { code: "2A", name: "Corse-du-Sud", slug: "corse-du-sud-2a" },
  { code: "2B", name: "Haute-Corse", slug: "haute-corse-2b" },
  { code: "30", name: "Gard", slug: "gard-30" },
  { code: "31", name: "Haute-Garonne", slug: "haute-garonne-31" },
  { code: "32", name: "Gers", slug: "gers-32" },
  { code: "33", name: "Gironde", slug: "gironde-33" },
  { code: "34", name: "Hérault", slug: "herault-34" },
  { code: "35", name: "Ille-et-Vilaine", slug: "ille-et-vilaine-35" },
  { code: "36", name: "Indre", slug: "indre-36" },
  { code: "37", name: "Indre-et-Loire", slug: "indre-et-loire-37" },
  { code: "38", name: "Isère", slug: "isere-38" },
  { code: "39", name: "Jura", slug: "jura-39" },
  { code: "40", name: "Landes", slug: "landes-40" },
  { code: "41", name: "Loir-et-Cher", slug: "loir-et-cher-41" },
  { code: "42", name: "Loire", slug: "loire-42" },
  { code: "43", name: "Haute-Loire", slug: "haute-loire-43" },
  { code: "44", name: "Loire-Atlantique", slug: "loire-atlantique-44" },
  { code: "45", name: "Loiret", slug: "loiret-45" },
  { code: "46", name: "Lot", slug: "lot-46" },
  { code: "47", name: "Lot-et-Garonne", slug: "lot-et-garonne-47" },
  { code: "48", name: "Lozère", slug: "lozere-48" },
  { code: "49", name: "Maine-et-Loire", slug: "maine-et-loire-49" },
  { code: "50", name: "Manche", slug: "manche-50" },
  { code: "51", name: "Marne", slug: "marne-51" },
  { code: "52", name: "Haute-Marne", slug: "haute-marne-52" },
  { code: "53", name: "Mayenne", slug: "mayenne-53" },
  { code: "54", name: "Meurthe-et-Moselle", slug: "meurthe-et-moselle-54" },
  { code: "55", name: "Meuse", slug: "meuse-55" },
  { code: "56", name: "Morbihan", slug: "morbihan-56" },
  { code: "57", name: "Moselle", slug: "moselle-57" },
  { code: "58", name: "Nièvre", slug: "nievre-58" },
  { code: "59", name: "Nord", slug: "nord-59" },
  { code: "60", name: "Oise", slug: "oise-60" },
  { code: "61", name: "Orne", slug: "orne-61" },
  { code: "62", name: "Pas-de-Calais", slug: "pas-de-calais-62" },
  { code: "63", name: "Puy-de-Dôme", slug: "puy-de-dome-63" },
  { code: "64", name: "Pyrénées-Atlantiques", slug: "pyrenees-atlantiques-64" },
  { code: "65", name: "Hautes-Pyrénées", slug: "hautes-pyrenees-65" },
  { code: "66", name: "Pyrénées-Orientales", slug: "pyrenees-orientales-66" },
  { code: "67", name: "Bas-Rhin", slug: "bas-rhin-67" },
  { code: "68", name: "Haut-Rhin", slug: "haut-rhin-68" },
  { code: "69", name: "Rhône", slug: "rhone-69" },
  { code: "70", name: "Haute-Saône", slug: "haute-saone-70" },
  { code: "71", name: "Saône-et-Loire", slug: "saone-et-loire-71" },
  { code: "72", name: "Sarthe", slug: "sarthe-72" },
  { code: "73", name: "Savoie", slug: "savoie-73" },
  { code: "74", name: "Haute-Savoie", slug: "haute-savoie-74" },
  { code: "75", name: "Paris", slug: "paris-75" },
  { code: "76", name: "Seine-Maritime", slug: "seine-maritime-76" },
  { code: "77", name: "Seine-et-Marne", slug: "seine-et-marne-77" },
  { code: "78", name: "Yvelines", slug: "yvelines-78" },
  { code: "79", name: "Deux-Sèvres", slug: "deux-sevres-79" },
  { code: "80", name: "Somme", slug: "somme-80" },
  { code: "81", name: "Tarn", slug: "tarn-81" },
  { code: "82", name: "Tarn-et-Garonne", slug: "tarn-et-garonne-82" },
  { code: "83", name: "Var", slug: "var-83" },
  { code: "84", name: "Vaucluse", slug: "vaucluse-84" },
  { code: "85", name: "Vendée", slug: "vendee-85" },
  { code: "86", name: "Vienne", slug: "vienne-86" },
  { code: "87", name: "Haute-Vienne", slug: "haute-vienne-87" },
  { code: "88", name: "Vosges", slug: "vosges-88" },
  { code: "89", name: "Yonne", slug: "yonne-89" },
  { code: "90", name: "Territoire de Belfort", slug: "territoire-de-belfort-90" },
  { code: "91", name: "Essonne", slug: "essonne-91" },
  { code: "92", name: "Hauts-de-Seine", slug: "hauts-de-seine-92" },
  { code: "93", name: "Seine-Saint-Denis", slug: "seine-saint-denis-93" },
  { code: "94", name: "Val-de-Marne", slug: "val-de-marne-94" },
  { code: "95", name: "Val-d'Oise", slug: "val-d-oise-95" },
  { code: "971", name: "Guadeloupe", slug: "guadeloupe-971" },
  { code: "972", name: "Martinique", slug: "martinique-972" },
  { code: "973", name: "Guyane", slug: "guyane-973" },
  { code: "974", name: "La Réunion", slug: "la-reunion-974" },
  { code: "976", name: "Mayotte", slug: "mayotte-976" },
] as const;
